import React, { useEffect, Suspense, lazy } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import { countryList } from "../../v2_actions/country";
import { PhotographerQuickLinkRouter } from "./PhotographerQuickLinkRouter";

import LoadingSpinner from "components/LoadingSpinner";
import { SignOut } from "../SignOut";

import { ConfirmationModal } from "../../v2_components/ConfirmationModal";
import ImageGallery from "../imagegallery";
import { GalleryEditor } from "../../v2_components/GalleryEditor";
import { MobilePhotographerHome } from "../../v2_components/MobilePhotographerHome";
import { MobileComingSoon } from "../../v2_components/MobileComingSoon";
import { MobileUpload } from "../../v2_components/MobileUpload";
import { MobileSales } from "../../v2_components/MobileSales";
import { MobileGalleries } from "../../v2_components/MobileGalleries";
// import { PhotoArtGalleryEditor } from '../../v2_components/PhotoArtGalleryEditor'
import { GalleryView } from "../../v2_components/GalleryView";
import { PhotoArtGalleryView } from "../../v2_components/PhotoArtGalleryView";
import { MapView } from "../../v2_components/MapView";
import { GalleriesView } from "../../v2_components/GalleriesView";
import { PhotoArtGalleriesView } from "../../v2_components/PhotoArtGalleriesView";
import { isLoggedIn } from "../../v2_actions/auth";
import ReactGA from "react-ga";

const Login = lazy(() => import("views/login"));
const Signup = lazy(() => import("views/signup"));
const Howwork = lazy(() => import("views/howwork"));
const SetPassword = lazy(() => import("views/setpassword"));
const App = lazy(() => import("layouts/App"));

if (get(window, ["LOCAL_SETTINGS", "GOOGLE_ANALYTICS_USERID"])) {
  ReactGA.initialize(window.LOCAL_SETTINGS.GOOGLE_ANALYTICS_USERID);
  ReactGA.pageview(window.location.pathname + window.location.search);
  ReactGA.set({ anonymizeIp: true, debug: true, siteSpeedSampleRate: 100 });
}

const MainRouter = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(countryList.loadAllCountries());
  }, []);

  const renderNotLoggedInRoutes = () => {
    return (
      <Switch>
        <Route
          path={`/za/customer/map/:photographerNickNameZa`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/au/customer/map/:photographerNickNameAu`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/us/customer/map/:photographerNickNameUs`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/za/:photographerNickNameZa`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/au/:photographerNickNameAu`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/us/:photographerNickNameUs`}
          component={PhotographerQuickLinkRouter}
        />

        <Route path={`/photographer/signup`} component={Signup} />
        <Route path={`/photographer/setpassword`} component={SetPassword} />
        <Route path={`/signout`} component={SignOut} />
        <Route path={`/`} component={Login} />
      </Switch>
    );
  };

  const renderLoggedInRoutes = () => {
    return (
      <Switch>
        <Route path={`/signout`} component={SignOut} />

        <Route
          path={`/customer/map/:photographerNickNameZa`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/au/customer/map/:photographerNickNameAu`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/us/customer/map/:photographerNickNameUs`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/za/:photographerNickNameZa`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/au/:photographerNickNameAu`}
          component={PhotographerQuickLinkRouter}
        />
        <Route
          path={`/us/:photographerNickNameUs`}
          component={PhotographerQuickLinkRouter}
        />

        <Route path={`/photographer/login`} component={Login} />
        <Route path={`/photographer/signup`} component={Signup} />
        <Route path={`/photographer/setpassword`} component={SetPassword} />
        <Route path={`/photographer/howitworks`} component={Howwork} />
        <Route path={`/photographer/mobile`} exact={true} component={MobilePhotographerHome} />
        <Route path={`/photographer/mobile-upload`} exact={true} component={MobileUpload} />
        <Route path={`/photographer/mobile-sales`} exact={true} component={MobileSales} />
        <Route path={`/photographer/mobile-galleries`} exact={true} component={MobileGalleries} />
        <Route path={`/photographer/creategallery`} component={ImageGallery} />

        <Route
          path={`/photographer/map`}
          exact={true}
          component={GalleriesView}
        />
        <Route
          path={`/photographer/map/new`}
          exact={true}
          component={GalleriesView}
        />
        <Route
          path={`/photographer/photo_art_gallery`}
          exact={true}
          component={PhotoArtGalleriesView}
        />
        <Route
          path={`/photographer/gallery`}
          exact={true}
          component={GalleryEditor}
        />
        <Route
          path={`/photographer/gallery/:gallery_id/map`}
          exact={true}
          component={MapView}
        />
        <Route
          path={`/photographer/gallery/:gallery_id/view`}
          exact={true}
          component={GalleryView}
        />
        <Route
          path={`/photographer/gallery/:gallery_id`}
          component={GalleryEditor}
        />
        <Route
          exact={true}
          component={PhotoArtGalleriesView}
          path={"/photographer/photo_art_gallery"}
        />
        <Route
          exact={true}
          component={PhotoArtGalleriesView}
          path={"/photographer/photo_art_gallery/new"}
        />
        <Route
          exact={true}
          component={PhotoArtGalleryView}
          path={"/photographer/photo_art_gallery/:gallery_id/view"}
        />
        <Route path={`/photographer`} component={App} />
        <Route path={`/`} component={Howwork} />
      </Switch>
    );
  };

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ConfirmationModal />

      {!isLoggedIn() && renderNotLoggedInRoutes()}
      {isLoggedIn() && renderLoggedInRoutes()}
    </Suspense>
  );
};

export default MainRouter;
